import {
  convertObjectKeysToSnakeCase,
  getWindowLocationValues,
} from './helpers'

/**
 * Track visibility events
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {string} event.elementId
 * @param {object} event.metadata
 * @param {object} event.scope
 */
export function trackVisibilityEvent(
  statsigClient,
  { elementId, metadata, scope },
) {
  statsigClient?.logEvent('visibility_changed', elementId, {
    element_id: elementId,
    ...convertObjectKeysToSnakeCase(metadata),
    ...getWindowLocationValues(scope),
  })
}
